/**
 * Integrytas Group - CSM
 * useActiveLocale — the single source of truth for "what locale is the UI showing
 * RIGHT NOW", for resolving DATA translations (`_tl` tables, §8).
 *
 * Why this exists: UI labels come from i18next (which the LanguageSwitcher updates
 * live via changeLanguage). But DATA translations (role/job/status names) are
 * resolved in page code by matching `_tl.locale_code`. Pages historically keyed
 * that off `session.effective_user.preferred_locale` — the STORED preference, which
 * is NOT updated in memory when the user switches locale at runtime. The result:
 * after a switch, chrome turns (e.g.) Spanish but role names stay English until
 * re-login. Resolving against the ACTIVE i18next language fixes that, and still
 * reflects the persisted preference on next load (the switcher seeds i18next from it).
 *
 * Returns a full CSM locale tag (e.g. 'EN_US' | 'ES_MX' | 'EN_GB') to match
 * `<code>_tl.locale_code`. Use this — not `preferred_locale` — for _tl display
 * resolution. (Keep `preferred_locale` for the DEFAULT locale of a NEW record.)
 */

import { useTranslation } from 'react-i18next';
import { csmLngTag, DEFAULT_CSM_LOCALE } from '../i18n';

export function useActiveLocale(): string {
  const { i18n } = useTranslation();
  return csmLngTag(i18n.language || DEFAULT_CSM_LOCALE);
}
